/* eslint-disable no-underscore-dangle, global-require */
// uncomment the following block, if you use ES6 syntax which needs polyfills.
/* if ((typeof window !== 'undefined' && !window._babelPolyfill) ||
  (typeof global !== 'undefined' && !global._babelPolyfill)) {
	require('@babel/polyfill');
} */
/* eslint-enable no-underscore-dangle, global-require */

// eslint-disable-next-line no-unused-vars
jQuery($ => {
	// some jquery code...
});
